import script from "./LoginRegisterResetWrapperBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginRegisterResetWrapperBox.vue?vue&type=script&lang=ts&setup=true"

import "./LoginRegisterResetWrapperBox.vue?vue&type=style&index=0&id=237db246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237db246"]])

export default __exports__